var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{attrs:{"label":_vm.getJobNumber,"type":"tertiary"},on:{"click":function($event){$event.stopPropagation();return _vm.pushSearchJobRoute.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }